/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logout': {
    width: 16,
    height: 14,
    viewBox: '0 0 16 14',
    data: '<path pid="0" d="M9.332 4.048V0H0v13.848h9.332v-3.835H8.053v2.557H1.278V1.278h6.775v2.77h1.279z"/><path pid="1" d="M4.325 7.67h9.206l-2.37 2.335.9.911L16 7.031l-3.94-3.886-.9.911 2.37 2.335H4.325V7.67z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/logout.js